import Emitter from "./Emitter";

export default class RequestRefresh extends Emitter {
    constructor(gb) {
        super(gb);
    }

    EXCITE_handler() {
        this.emitParent({ event: "requestRefresh" });
    }

    MGS_handler() {
        this.emitParent('{"Name" : "reload_game", "Origin" : "embeddedgame"}');
    }

    _default() {
        this.emitTop({ wpgaction: "requestRefresh" });
        this.emitParent({ wpgaction: "requestRefresh.parent" });
        this.emitiOS({ wpgaction: "requestRefresh" });

    }
}
